import logger from '@/modules/Logger';
import { BANDWIDTH_THRESHOLDS, BUFFER_SWITCH_MIN_COUNT } from '@/modules/webrtc/agora/const';

let newUplinkQuality = {};

export default {
  async setQualityOnUpLinkSpeed(quality) {
    newUplinkQuality = this.setQualityOfNetwork(quality);

    if (this.upLinkNetworkQuality === newUplinkQuality.value) {
      return;
    }

    if (this.shouldApplyBufferSwitchOnUplink()) {
      this.switchUpLinkBuffer.push(newUplinkQuality.value);
      return;
    }

    await this.setSendStreamQuality(newUplinkQuality);
  },

  async setSendStreamQuality(newUplinkQuality) {
    this.switchUpLinkBuffer = [];
    this.upLinkNetworkQuality = newUplinkQuality.value;

    logger.info('[Agora] Uplink network changes, switch send stream quality', {
      operation: 'webrtc:call-quality',
      quality: newUplinkQuality.label
    });

    try {
      // set local video stream resolution
      await this.localVideoTrack?.setEncoderConfiguration(newUplinkQuality.profile);

      // enable or disable dual stream based on network quality
      await this.updateDualStreamQuality();
    } catch (error) {
      logger.error('[Agora] Error while setting send stream quality', {
        operation: 'webrtc:call-quality',
        error: error.message,
        event_type:52,lesson_id:this.lessonId
      });
    }
  },

  async updateDualStreamQuality() {
    this.isUpLinkExcellentQuality()
      ? await this.rtc.enableDualStream()
      : await this.rtc.disableDualStream();
  },

  /*
   * When the network quality improves, apply buffering to minimize frequent switching.
   * On the contrary, when the network quality deteriorates, switch immediately
   */
  shouldApplyBufferSwitchOnUplink() {
    if (newUplinkQuality.value === BANDWIDTH_THRESHOLDS.poor.value) {
      this.switchUpLinkBuffer = [];
      return false;
    }

    return !this.isUpLinkExcellentQuality() && this.switchUpLinkBuffer.length < BUFFER_SWITCH_MIN_COUNT;
  }
};
